const Actions = {
  GET_UNBATCHED_DOCS_SUMMARY: "GET_UNBATCHED_DOCS_SUMMARY",
  GET_UNBATCHED_DOCS_SUMMARY_SUCCEEDED: "GET_UNBATCHED_DOCS_SUMMARY_SUCCEEDED",
};

export default Actions;
